module.exports = __webpack_public_path__ + "198f2a31dc45887bde16f1ed6a7efccc.jpg";